import Noty from 'noty';

document.addEventListener("DOMContentLoaded", function() {
  showFlashMessages();
});

function showFlashMessages() {
  let flash = document.querySelectorAll('.flash');
  
  flash.forEach(function(element) {
    if (element.dataset.flashText) {
      if (element.dataset.flashType === 'notice') {
        element.dataset.flashType = 'success'
      }
      new Noty({
         type: element.dataset.flashType,
         layout: 'topCenter',
         theme: 'nest',
         text: element.dataset.flashText,
         timeout: '4000',
         progressBar: true,
         closeWith: ['click', 'button'],
         killer: true,
         animation: {
             open: 'animated bounceInDown',
             close: 'animated bounceOutUp'
           }
      }).show();
    }
  });
}
